module.exports = __webpack_public_path__ + "img/genicon-judge-male.801d6e2d.svg";